import React from 'react';
import PropTypes from 'prop-types';
import CustomerContactInfoComp from './CustomerContactInfoComp';


// I had to put different name value for html view
// to make autofill work correctly
// @see SBOOK-6.
const CustomerContactInfoStreetNumber = props => (
<CustomerContactInfoComp
  {...props}
  errorMessages={{
    'field_is_required': 'The house number field is required',
    'field_is_invalid': 'Your house number is invalid',
  }}
  htmlAttrName="buildingNumber"
  label="House number"
  name="streetNumber"
  onChange={(name, data) => props.onChange('streetNumber',
    data)}
  validate={data => props.validate({streetNumber: data.buildingNumber})}
/>
);

CustomerContactInfoStreetNumber.PropTypes = {
  validate:PropTypes.func,
  onChange:PropTypes.func.isRequired,
};

export default CustomerContactInfoStreetNumber;
